import Vue from 'vue'

export const seoState = Vue.observable({
  page: null,
})
